<template>
  <Loader v-if="isLoading" size="lg"></Loader>
  <div class="pt-0" v-else>
    <table v-if="idFirm.userDataEmployees.length > 0" class="table table-sm table-striped table-hover mb-3">
      <thead>
      <tr>
        <!--                <th style="width: 20%">{{$t('views.firm.show.userDataEmployee.index')}}:</th>-->
        <th>{{$t('views.firm.show.userDataEmployee.nameAndSurname')}}:</th>
        <th>{{$t('views.firm.show.userDataEmployee.userEmail')}}:</th>
        <th>{{$t('views.firm.show.userDataEmployee.mobilePhone')}}:</th>
        <th>{{$t('views.userdataemployee.form.employeePosition')}}:</th>
        <th>{{$t('views.firm.show.userDataEmployee.isContactPerson')}}:</th>
        <th>{{$t('views.firm.show.userDataEmployee.vatInvoiceRecipient')}}:</th>
        <th v-if="displaySalesRepresentative">{{$t('views.userdata.form.idSalesRepresentative')}}:</th>
        <th v-if="displayCaseTypesAllowedForNotification">{{$t('views.userdataemployee.form.caseTypesAllowedForNotification')}}:</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(userDataEmployee, userDataEmployeeIndex) in idFirm.userDataEmployees" v-bind:key="'userDataEmployee-' + userDataEmployeeIndex">
        <td>
          <router-link :to="{name: 'UserDataShow', params: { id: userDataEmployee.employee['@id'] }}">
            {{ userDataEmployee.employee['name'] }} {{ userDataEmployee.employee['surname'] }}
          </router-link>
        </td>
        <td><a :href="'mailto: ' + userDataEmployee.employee['userEmail']">{{ userDataEmployee.employee['userEmail'] }}</a></td>
        <td>
          <phoneNumberLink :phoneNumber="userDataEmployee.employee['mobilePhone']"/>
        </td>
        <td>
          <span v-if="userDataEmployee.employee.workplace">{{ userDataEmployee.employee.workplace.title }}</span>
        </td>
        <td>
          <span v-if="userDataEmployee['isContactPerson'] === 1">{{ $t('buttons.yes') }}</span><span v-else>{{ $t('buttons.no') }}</span>
        </td>
        <td>
          <span v-if="userDataEmployee['vatInvoiceRecipient'] === 1">{{ $t('buttons.yes') }}</span><span v-else>{{ $t('buttons.no') }}</span>
        </td>
        <td v-if="displaySalesRepresentative">
          <span v-if="userDataEmployee.employee.idSalesRepresentative">{{ userDataEmployee.employee.idSalesRepresentative.name }} {{ userDataEmployee.employee.idSalesRepresentative.surname }}</span>
        </td>
        <td v-if="displayCaseTypesAllowedForNotification">
          {{ getCaseTypeTitlesById(userDataEmployee.caseTypesAllowedForNotification) }}
        </td>
        <td>
          <b-dropdown v-if="ableToEditFirm || ableToUserDataShow || ableToUserShow" size="sm" variant="link" right text="Right align" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <i class="fa fa-bars fa-lg"></i>
            </template>
            <b-dropdown-item v-if="ableToEditFirm" @click="createUserToUserData(userDataEmployee.employee['@id'])">
              <i class="fas fa-user-plus fa-lg mr-2"></i>
              {{$t('buttons.createAccount')}}
            </b-dropdown-item>
            <b-dropdown-item v-if="ableToEditFirm" @click="editEmployee(userDataEmployee)">
              <i class="fa fa-pencil fa-lg mr-2"></i>
              {{$t('buttons.edit')}}
            </b-dropdown-item>
            <b-dropdown-item v-if="ableToEditFirm" @click="deleteItem(userDataEmployee)">
              <i class="fas fa-trash fa-lg mr-2"></i>
              {{$t('buttons.delete')}}
            </b-dropdown-item>
            <b-dropdown-item v-if="ableToUserDataShow" @click="goToUserDataShow(userDataEmployee.employee['@id'])">
              <i class="fa fa-address-card fa-lg mr-2"></i>
              {{$t('views.firm.show.userDataEmployee.options.userDataShow')}}
            </b-dropdown-item>
            <b-dropdown-item v-if="ableToUserShow" @click="goToUserShow(userDataEmployee.employee.users[0])">
              <i class="fa fa-user-circle fa-lg mr-2"></i>
              {{$t('views.firm.show.userDataEmployee.options.userShow')}}
            </b-dropdown-item>
          </b-dropdown>
        </td>
      </tr>
      </tbody>
    </table>
    <button v-if="ableToEditFirm"
            type="button"
            class="btn btn-sm btn-primary"
            @click="addEmployee()">
      {{ $t('views.firm.form.addNewEmployee') }}
    </button>
    <button
            v-if="ableToAddUserData"
            type="button"
            class="btn btn-sm btn-primary"
            @click="toggleUserDataModal">
      {{ $t('menu.userdatas.create') }}
    </button>
    <create-user-data-modal :client-type="getClientTypeIRI(7)"></create-user-data-modal>
  </div>
</template>

<script>
import { checkPermission } from '@/utils/checkRoles.js'
import getId from '@/utils/getIdFromLink'
import Loader from '../../../Layout/Loader'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ApiService from '@/utils/ApiService'
import CreateUserDataModal from '@/components/Dashboard/Views/userdata/modals/CreateModal'
import { ENTRYPOINT } from '@/config/entrypoint'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'
export default {
  name: 'EmployeeList',
  components: {
    PhoneNumberLink,
    Loader,
    CreateUserDataModal
  },
  props: {
    ableToEditFirm: {
      required: false
    },
    idFirm: {
      type: Object,
      required: true
    }
  },
  watch: {
  },
  created () {
    this.getCaseType()
  },
  computed: {
    ...mapGetters({
      isLoading: 'userdataemployee/list/isLoading',
      casetype: 'excmcasetype/list/items'
    }),
    ableToUserDataShow () {
      return this.checkRoles('userdatas', 'UserDataShow')
    },
    ableToUserShow () {
      return this.checkRoles('userdatas', 'UserShow')
    },
    ableToViewAgreements () {
      return this.checkRoles('agreements', 'EXCMAgreementList')
    },
    ableToViewInovices () {
      return this.checkRoles('finances', 'EXSBInvoiceList')
    },
    ableToAddUserData () {
      return this.checkRoles('userdatas', 'UserDataCreate')
    },
    displaySalesRepresentative () {
      for (let i in this.idFirm.userDataEmployees) {
        if (this.idFirm.userDataEmployees[i].employee.idSalesRepresentative) {
          return true
        }
      }
      return false
    },
    displayCaseTypesAllowedForNotification () {
      for (let i in this.idFirm.userDataEmployees) {
        if (this.idFirm.userDataEmployees[i].caseTypesAllowedForNotification && this.idFirm.userDataEmployees[i].caseTypesAllowedForNotification.length > 0) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    getClientTypeIRI (id) {
      let url = new URL(ENTRYPOINT)
      return url.pathname + 'client_types/' + id
    },
    goToUserDataShow (id) {
      this.$router.push({ name: 'UserDataShow', params: { id: id } })
    },
    goToUserShow (id) {
      this.$router.push({ name: 'UserShow', params: { id: id } })
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },
    async createUserToUserData (userDataIRI) {
      await new ApiService(`user_datas/${userDataIRI}/add_user`)
    },
    ...mapMutations({
      toggleUserDataModal: 'userdata/createModal/toggleModal'
    }),
    ...mapActions({
      del: 'userdata/del/del',
      retrieve: 'userdata/show/retrieve',
      getCaseType: 'excmcasetype/list/default'
    }),
    getIdLink (link) {
      return getId(link)
    },
    addEmployee () {
      this.$store.state.modals.userdataemployee.create.show = 1
      this.$store.state.modals.userdataemployee.create.firmIRI = this.idFirm['@id']
    },
    editEmployee (pivot) {
      this.$store.state.modals.userdataemployee.update.show = 1
      this.$store.state.modals.userdataemployee.update.userDataEmployeePivot = pivot
    },
    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        text: this.$t('notifications.deleteDescription'),
        type: 'warning',
        showCancelButton: true,
        // confirmButtonColor: '#3085d6',
        // cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(response => {
        this.del(item).then(() => this.retrieve(decodeURIComponent(this.$route.params.id)))
        this.$Swal({
          title: this.$t('notifications.deletedTitle'),
          type: 'success'
        })
      }, dismiss => {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          this.$Swal({
            title: this.$t('notifications.deleteCancel'),
            type: 'error'
          })
        }
      })
    },
    getCaseTypeTitlesById (caseTypes) {
      let caseTypeTitles = []
      for (let i in this.casetype) {
        if (caseTypes.includes(getId(this.casetype[i]['@id']))) {
          caseTypeTitles.push(this.casetype[i].title)
        }
      }
      return caseTypeTitles.join(', ')
    }
  }
}
</script>

<style scoped>

</style>
